import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mlc-layer-item-checkbox-label-container" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mlc-layer-item-opacity-label-container" }
const _hoisted_6 = ["for"]

import { watch } from "vue";
import type { Map } from "maplibre-gl";
import { useMaplibreLayerOpacity } from "@/composables/useMaplibreLayerOpacity";
import { useMaplibreLayerVisibility } from "@/composables/useMaplibreLayerVisibility";

interface Props {
  layerId: string;
  map: Map;
  displayName?: string;
  info?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MaplibreLayerControlItem',
  props: {
    layerId: {},
    map: {},
    displayName: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;
let { opacity } = useMaplibreLayerOpacity(props.map, props.layerId);
let { visible } = useMaplibreLayerVisibility(props.map, props.layerId);

// NB: If the props update, we need to make sure that the refs that we're using are still tracking the same layer
// In particular, if the layer ID changes, without this the component can end up manipulating the wrong layer!
watch(() => [props.map, props.layerId],
  ([map, layerId]: [Map, string]) => {
    opacity = useMaplibreLayerOpacity(map, layerId).opacity;
    visible = useMaplibreLayerVisibility(map, layerId).visible;
  });

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_popup_info_button = _resolveComponent("popup-info-button")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", {
    id: `mlc-layer-item-${__props.layerId}`,
    class: _normalizeClass(['mlc-layer-item', `mlc-layer-item-${_unref(visible) ? 'visible' : 'none'}`])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_checkbox, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
        id: `mlc-${__props.layerId}-visibility-checkbox`,
        class: "mlc-layer-item-checkbox",
        density: "compact",
        "hide-details": "",
        color: "primary"
      }, null, 8, ["modelValue", "id"]),
      _createElementVNode("label", {
        class: "mlc-layer-item-label",
        for: `mlc-${__props.layerId}-visibility-checkbox`
      }, _toDisplayString(__props.displayName ?? __props.layerId), 9, _hoisted_3),
      (__props.info)
        ? (_openBlock(), _createBlock(_component_popup_info_button, {
            key: 0,
            "info-text": __props.info
          }, {
            info: _withCtx(() => [
              _createElementVNode("div", { innerHTML: __props.info }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["info-text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", {
        for: `mlc-${__props.layerId}-opacity-slider`
      }, " Opacity: ", 8, _hoisted_6),
      _createVNode(_component_v_slider, {
        modelValue: _unref(opacity),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(opacity) ? (opacity).value = $event : opacity = $event)),
        modelModifiers: { number: true },
        id: `mlc-${__props.layerId}-opacity-slider`,
        class: "mlc-layer-opacity-slider",
        min: 0,
        max: 1,
        step: 0.01,
        title: "Adjust layer opacity",
        color: "primary",
        "hide-details": ""
      }, null, 8, ["modelValue", "id"])
    ]),
    _renderSlot(_ctx.$slots, "actions", { visible: _unref(visible) })
  ], 10, _hoisted_1))
}
}

})